import { makeAutoObservable } from 'mobx';
import { tourTypeEnum } from './types';

export interface IWebTutorialStore {
  isTourOpen: boolean;
  replayAppType: tourTypeEnum | string;
  setReplayAppType(type: tourTypeEnum, isReplayFromHelp?: boolean): void;
  toggleTourState(state: boolean): void;
  isReplayFromHelp: boolean;
}

export class WebTutorialStore implements IWebTutorialStore {
  isTourOpen = true;
  isReplayFromHelp = false;
  replayAppType = '';

  constructor() {
    makeAutoObservable(this);
  }

  toggleTourState(state: boolean) {
    this.isTourOpen = state;
  }

  setReplayAppType(type: tourTypeEnum, isReplayFromHelp?: boolean) {
    this.replayAppType = type;
    this.toggleTourState(true);
    this.isReplayFromHelp = isReplayFromHelp ?? false;
  }
}
